import { render, staticRenderFns } from "./ManufacturingOrdersTable.vue?vue&type=template&id=271a5242&"
import script from "./ManufacturingOrdersTable.vue?vue&type=script&lang=js&"
export * from "./ManufacturingOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports